import React, { useRef } from 'react';
import { useDrop } from 'react-dnd';
import type { DropTargetMonitor } from 'react-dnd';

interface Props {
  children: React.ReactNode;
  onDrop: (item: any, position: { x: number; y: number }) => void;
  width?: number;
  height?: number;
  className?: string;
}

const DropZone: React.FC<Props> = ({ children, onDrop, width, height, className = '' }) => {
  const ref = useRef<HTMLDivElement>(null);

  const [, drop] = useDrop({
    accept: 'ITEM',
    drop: (item: any, monitor: DropTargetMonitor) => {
      const offset = monitor.getClientOffset();
      if (offset && ref.current) {
        const rect = ref.current.getBoundingClientRect();
        const position = {
          x: offset.x - rect.left,
          y: offset.y - rect.top,
        };
        onDrop(item, position);
      }
    },
  });

  drop(ref);

  return (
    <div
      ref={ref}
      className={`relative bg-gray-100 rounded-lg border-2 border-dashed border-gray-300 ${className}`}
      style={{
        width: width || '100%',
        height: height || '100%',
        backgroundImage: `
          linear-gradient(to right, #e5e7eb 1px, transparent 1px),
          linear-gradient(to bottom, #e5e7eb 1px, transparent 1px)
        `,
        backgroundSize: '20px 20px',
      }}
    >
      {children}
    </div>
  );
};

export default DropZone; 